import cloneDeep from 'lodash/cloneDeep';
import { ACCT_INACCESSIBLE } from '../../src/constants/api-error-enums';
import isEmptyObject from '../../src/helpers/is-empty-object';
import isRecognizedMul from '../api/is-recognized-mul';
import * as EVENTS from '../constants/external-events';
import OrchCustomData from '../helpers/orch-custom-data';
import sendMessageToVisaSrci from '../helpers/send-message-to-visa-srci';

const handleIsRecognizedPreference = () => {
  const eventId = EVENTS.ORCH_IS_RECOGNIZED;
  let isRecognizedRes = OrchCustomData.srcSdks.apiResponseCache.isRecognized;
  // if response cache is empty object, call isRecognized to all networks and cache the response
  if (isEmptyObject(isRecognizedRes)) {
    isRecognizedMul();
  } else {
    // pull from isRecognized cache again
    isRecognizedRes = OrchCustomData.srcSdks.apiResponseCache.isRecognized;
    let response = {};
    for (const key in isRecognizedRes) {
      if (isRecognizedRes[key]?.recognized) {
        response = isRecognizedRes[key];
        break;
      }
    }

    if (isEmptyObject(response)) {
      for (const key in isRecognizedRes) {
        const systemRes = isRecognizedRes[key];
        if (systemRes && systemRes.error && systemRes.error.reason === ACCT_INACCESSIBLE) {
          response = isRecognizedRes[key];
          break;
        }
      }
    }

    if (isEmptyObject(response)) {
      response = { recognized: false };
    }

    // When we generated the SSI/ERM token while on the merchant page, we added a timestamp of when the token was created so the app can calculate
    // how long the user was on the merchant page before starting the app, this way the app can correctly start its session timer.
    // We only want to send the app this response with the timestamp on the very first this function is invoked. So, we need to
    // delete the timestamp from the cached response and ensure we don't send it on every subsequent request.
    const finalResponse = cloneDeep(response);
    if (
      response.customData &&
      response.customData.data &&
      response.customData.data.creation_timestamp
    ) {
      delete response.customData.data.creation_timestamp;
    }
    sendMessageToVisaSrci(eventId, finalResponse);
  }
};

export default handleIsRecognizedPreference;
